import { loadTracks, fetchActions } from './map';

export const SET_USERS_FILTER = 'SET_USERS_FILTER';
export const SET_USERS_FILTER_ACTIVE = 'SET_USERS_FILTER_ACTIVE';
export const SET_SEARCHBOX_TEXT = 'SET_SEARCHBOX_TEXT';
export const SELECT_TOOL_USER = 'SELECT_TOOL_USER';
export const VIDEO_TIME_UPDATE = 'VIDEO_TIME_UPDATE';
export const VIDEO_SELECT_MEDIA_INDEX = 'VIDEO_SELECT_MEDIA_INDEX';
export const VIDEO_SET_ABSOLUTETIME = 'VIDEO_SET_ABSOLUTETIME';
export const SET_VIDEO_STATE = 'SET_VIDEO_STATE';
export const SET_TRACK_HINT = 'SET_TRACK_HINT';
export const SET_ADMIN_CHECK = 'SET_ADMIN_CHECK';
export const SET_ADMIN_CHECK_STEP = 'SET_ADMIN_CHECK_STEP';
export const RECEIVE_ADMIN_CHECK = 'RECEIVE_ADMIN_CHECK';
export const SET_ADMIN_CHECK_ACTIVE = 'SET_ADMIN_CHECK_ACTIVE';
export const SELECT_VIDEO_TOOL = 'SELECT_VIDEO_TOOL';
export const SET_VIDEO_STEP = 'SET_VIDEO_STEP';

export function setUsersFilter(filter) {
  return { type: SET_USERS_FILTER, filter };
}

export function setUsersFilterActive(active) {
  return { type: SET_USERS_FILTER_ACTIVE, active };
}

export function setSearchBoxText(text) {
  return { type: SET_SEARCHBOX_TEXT, text };
}

export function selectUser(user, group, center) {
  return (dispatch, getState) => {
    if (user) {
      fetchAdminCheck(user, dispatch, getState);
    } else {
      dispatch(selectVideoTool(false));
    }
    dispatch({ type: SELECT_TOOL_USER, user, group, center });
    const { selectedDay, selectionMode } = getState().map;
    if (selectionMode === 'single') {
      dispatch(loadTracks(selectedDay.date,
        () => dispatch({ type: SELECT_TOOL_USER, user, group, center }),
      ));
    }
  };
}

function fetchAdminCheck(user, dispatch, getState) {
  const track = getState().map.selectedDay.tracks[user.id];
  if (track) {
    fetchActions('adminchecks', {
      trackId: track.trackId,
      checkdate: getState().map.selectedDay.date,
      changed: track.adminCheckChanged,
    }, dispatch);
  }
}

export function selectTrack(track) {
  return (dispatch, getState) => {
    const user = getState().map.usersMap[track.trackId];
    dispatch(selectUser(user));
  };
}

export function updateVideoTime(time, duration, playbackRate) {
  return { type: VIDEO_TIME_UPDATE, time, duration, playbackRate };
}

export function selectMediaIndex(mediaIndex) {
  return { type: VIDEO_SELECT_MEDIA_INDEX, mediaIndex };
}

export function setAbsoluteTime(mediaIndex, absoluteTime) {
  return { type: VIDEO_SET_ABSOLUTETIME, mediaIndex, absoluteTime };
}

function getMediaInfo({ map, tools }) {
  const { selectedDay, selectedUser } = map;
  const { selectedMediaIndex, videoStep } = tools;
  if (selectedDay && selectedUser) {
    const selectedTrack = selectedDay.tracks[selectedUser.id];
    if (selectedTrack) {
      const { medias } = selectedTrack;
      return { selectedTrack, selectedMediaIndex, medias, videoStep };
    }
  }
  return {};
}

export function selectNextMedia() {
  return (dispatch, getState) => {
    const { selectedMediaIndex, medias, videoStep } = getMediaInfo(getState());
    if (selectedMediaIndex < (medias.length - 1)) {
      const index = Math.min(selectedMediaIndex + videoStep, medias.length - 1);
      return dispatch(selectMediaIndex(index));
    }
    return undefined;
  };
}

export function selectPrevMedia() {
  return (dispatch, getState) => {
    const { selectedMediaIndex, videoStep } = getMediaInfo(getState());
    if (selectedMediaIndex > 0) {
      const index = Math.max(selectedMediaIndex - videoStep, 0);
      return dispatch(selectMediaIndex(index));
    }
    return undefined;
  };
}

export function selectFirstMedia() {
  return selectMediaIndex(0);
}

export function selectLastMedia() {
  return (dispatch, getState) => {
    const { medias } = getMediaInfo(getState());
    if (medias.length > 0) {
      return dispatch(selectMediaIndex(medias.length - 1));
    }
    return undefined;
  };
}

export function setVideoState(state) {
  return { type: SET_VIDEO_STATE, state };
}

export function selectMedia(track, media, absoluteTime) {
  return (dispatch, getState) => {
    const { selectedTrack } = getMediaInfo(getState());
    if (!selectedTrack || track !== selectedTrack) {
      const user = getState().map.usersMap[track.trackId];
      dispatch(selectUser(user));
    }
    const mediaIndex = track.medias.findIndex(item => item.filename === media.filename);
    if (!getState().tools.videoToolSelected) {
      dispatch(selectVideoTool(true));
    }
    dispatch(setAbsoluteTime(mediaIndex, absoluteTime));
  };
}

export function setTrackHint(track, absoluteTime) {
  return { type: SET_TRACK_HINT, track, absoluteTime };
}

export function setAdminCheck(input) {
  const changed = Date.now();
  return (dispatch, getState) => {
    const track = getState().map.selectedTrack;
    const value = input > 0 ? input : 0;
    if (track) {
      fetchActions('adminchecks/post', {
        changed,
        trackId: track.trackId,
        checkdate: getState().map.selectedDay.date,
        count: value,
      }, dispatch);
      dispatch({ type: SET_ADMIN_CHECK, value, changed });
    }
  };
}

export function setAdminCheckStep(value) {
  return { type: SET_ADMIN_CHECK_STEP, value };
}

export function incAdminCheck() {
  return (dispatch, getState) => {
    const track = getState().map.selectedTrack;
    if (track) {
      dispatch(setAdminCheck(track.adminCheck + track.adminCheckStep));
    }
  };
}

export function decAdminCheck() {
  return (dispatch, getState) => {
    const track = getState().map.selectedTrack;
    if (track) {
      dispatch(setAdminCheck(track.adminCheck - track.adminCheckStep));
    }
  };
}

export function setAdminCheckActive(active) {
  return { type: SET_ADMIN_CHECK_ACTIVE, active };
}

export function selectVideoTool(selected = true) {
  return { type: SELECT_VIDEO_TOOL, selected };
}

export function toggleVideoTool() {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_VIDEO_TOOL,
      selected: !getState().tools.videoToolSelected,
    });
  };
}

export function setVideoStep(videoStep) {
  return { type: SET_VIDEO_STEP, videoStep };
}



// WEBPACK FOOTER //
// ./src/actions/tools.js